const formatPrice = (value = 0.0): string => {
  const defaultOptions = {
    significantDigits: 2,
    thousandsSeparator: ',',
    decimalSeparator: '.',
  };

  const price = value.toFixed(defaultOptions.significantDigits);

  const [currency, decimal] = price.split('.');
  return `${currency?.replace(/\B(?=(\d{3})+(?!\d))/g, defaultOptions.thousandsSeparator)}${
    defaultOptions?.decimalSeparator
  }${decimal}`;
};

export const formatPriceWithoutDecimal = (n: number): string =>
  formatPrice(n)?.split('.')[0];
